"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const mobx_react_1 = require("mobx-react");
const lodash_1 = require("lodash");
const fx_1 = require("../../lib/fx");
if (process.env.BROWSER) {
    require('./index.less');
}
let loaded;
const body = document.getElementsByTagName('body')[0];
let start = { x: 0, y: 0 };
let delta = { x: 0, y: 0 };
let isScrolling = false;
let isDraging = false;
let hasCallback = false;
let isScrollEnd = false;
const isInit = false;
// 最小滑动距离
const minOffset = 0;
// 释放距离
const pullOffset = 120;
let lastBodyStyle = '';
let SwipeUpBack = class SwipeUpBack extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            isScrollEnd: true,
        };
    }
    componentDidMount() {
        if (loaded) {
            return;
        }
        const html = document.getElementsByTagName('html')[0];
        html.style.position = 'relative';
        html.style.height = 'auto';
        body.style.height = 'auto';
        this.bindEvent();
        loaded = true;
    }
    callback() {
        if (hasCallback) {
            return;
        }
        hasCallback = true;
        console.log('触发');
        fx_1.callJssdk('alphaNews.notifyBack', {
            type: '0',
            tab: '1',
            channelid: '',
            animation: '4',
        });
    }
    isModal() {
        return body.getAttribute('modal') === 'open';
    }
    bindEvent() {
        document.addEventListener('scroll', lodash_1.throttle(() => {
            const screenHeight = window.innerHeight || document.documentElement.clientHeight;
            isScrollEnd = fx_1.getScrollHeight() - (fx_1.getScrollTop() + screenHeight) <= 0;
            if (isScrollEnd) {
                // swipeUp.showTip();
            }
        }, 50));
        body.addEventListener('touchstart', this.touchstart.bind(this), {
            passive: true,
        });
        body.addEventListener('touchmove', lodash_1.throttle(this.touchmove.bind(this), 50), {
            passive: true,
        });
        body.addEventListener('touchend', this.touchend.bind(this), {
            passive: true,
        });
    }
    touchstart(event) {
        if (!isScrollEnd) {
            return;
        }
        if (this.isModal()) {
            return;
        }
        const touches = event.touches[0];
        start = {
            x: touches.clientX,
            y: touches.clientY,
            time: +new Date(),
        };
        isScrolling = undefined;
        isDraging = true;
        delta = {};
        hasCallback = false;
        lastBodyStyle = body.getAttribute('style') || '';
        this.translate(0);
    }
    touchmove(event) {
        if (!isDraging) {
            return;
        }
        if (this.isModal()) {
            return;
        }
        if (event.touches.length > 1 || (event.scale && event.scale !== 1)) {
            return;
        }
        const touches = event.touches[0];
        delta = {
            x: touches.clientX - start.x,
            y: touches.clientY - start.y,
        };
        if (typeof isScrolling === 'undefined') {
            isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
        }
        if (isScrolling) {
            // event.preventDefault();
            let trans = delta.y;
            if (trans < 0) {
                body.classList.add('body-fixed');
                trans = Math.abs(trans) < pullOffset ? trans : -pullOffset;
                if (trans === -pullOffset) {
                    this.callback();
                }
                this.translate(trans);
            }
            else {
                this.translate(0);
            }
        }
    }
    touchend(event) {
        if (!isDraging) {
            return;
        }
        if (this.isModal()) {
            return;
        }
        const duration = +new Date() - start.time;
        const direction = delta.x < 0;
        body.classList.remove('body-fixed');
        this.translate(0, 300);
        setTimeout(() => {
            const style = body.style;
            style.msTransform = style.MozTransform = style.OTransform = '';
            style.webkitTransform = '';
        }, 300);
        isDraging = false;
    }
    translate(dist, speed) {
        const style = body.style;
        if (!style) {
            return;
        }
        // if (!isScrollEnd) {
        //   body.setAttribute('style', lastBodyStyle);
        //   return;
        // }
        style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
            speed + 'ms';
        style.webkitTransform = 'translate(0, ' + dist + 'px)' + 'translateZ(0)';
        style.msTransform = style.MozTransform = style.OTransform =
            'translateY(' + dist + 'px)';
    }
    render() {
        return (React.createElement("div", { className: "pull-up", id: "pull-up" },
            React.createElement("div", { className: "pull-up-content" },
                React.createElement("span", { className: "pull-up-icon" }, "\u279C"),
                ' ',
                React.createElement("span", { className: "text" }, "Slide Up to go back"))));
    }
};
SwipeUpBack = tslib_1.__decorate([
    mobx_react_1.observer,
    tslib_1.__metadata("design:paramtypes", [Object])
], SwipeUpBack);
exports.default = SwipeUpBack;
//# sourceMappingURL=data:application/json;base64,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